import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  IconButton,
  Grid,
  Button,
} from '@material-ui/core'
import { Add as AddIcon, Delete as DeleteIcon } from '@material-ui/icons'

import { mdiPencil } from '@mdi/js'
import { useDispatch, useSelector } from 'react-redux'

import { Creators as DepartmentsActions } from '~/store/ducks/departments'
import { Creators as DepartmentActions } from '~/store/ducks/department'

import Portlet from '~/components/Portlet'
import ListFooter from '~/components/ListFooter'
import ConfirmDialog from '~/components/ConfirmDialog'
import CustomIcon from '~/components/CustomIcon'
import SearchInput from '~/components/SearchInput'
import { useSmallScreen } from '~/helpers/useMediaQuery'
import OverlayLoading from '~/components/OverlayLoading'
import EmptyList from '~/components/EmptyList'
import styles from './styles'
import DepartmentDialog from './components/DepartmentDialog'

const departmentsSelector = ({ departments }) => departments

const useStyles = makeStyles(styles)

function DepartmentsPage() {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [openConfirmDialog, setConfirmDialog] = useState(false)
  const [departmentId, setDepartmentId] = useState(null)
  const [openDeparmentDialog, setOpenDepartmentDialog] = useState(false)
  const { data, options, loading } = useSelector(departmentsSelector)
  const { sort, direction } = options
  const isSmallScreen = useSmallScreen()

  useEffect(() => {
    dispatch(DepartmentsActions.getDepartmentsRequest())
  }, [])

  const handleSortChange = (newSort) => {
    const isSameSort = newSort === sort
    let sortDirection = direction

    if (isSameSort) {
      if (direction === 'asc') {
        sortDirection = 'desc'
      } else {
        sortDirection = 'asc'
      }
    }

    dispatch(DepartmentsActions.setDepartmentsSort(newSort, sortDirection))
  }

  const handleChangeRowsPerPage = (ev) => {
    const {
      target: { value },
    } = ev
    dispatch(DepartmentsActions.setDepartmentsPage(0, value))
  }

  const handleChangePage = (_, page) => {
    dispatch(DepartmentsActions.setDepartmentsPage(page, options.limit))
  }

  const handleSearchChange = (value) => {
    dispatch(DepartmentsActions.setDepartmentsSearch(value))
  }

  const handleEditDepartment = (id) => {
    setDepartmentId(id)
    setOpenDepartmentDialog(true)
  }
  const handleAddDepartment = () => {
    setOpenDepartmentDialog(true)
  }

  const handleCloseDeparmentDialog = () => {
    setDepartmentId(null)
    setOpenDepartmentDialog(false)
  }

  const handleRemoveDepartment = (id) => {
    setDepartmentId(id)
    setConfirmDialog(true)
  }

  const handleRemoveCancel = () => {
    setDepartmentId(null)
    setConfirmDialog(false)
  }

  const handleRemoveAccept = () => {
    dispatch(
      DepartmentActions.removeDepartmentRequest(departmentId, () => {
        dispatch(DepartmentsActions.getDepartmentsRequest())
        setDepartmentId(null)
        setConfirmDialog(false)
      }),
    )
  }

  return (
    <>
      <div className={classes.root}>
        <Grid
          container
          justifyContent="space-between"
          className={classes.gridContainerButton}
        >
          <Grid item xs={12} md={6}>
            <SearchInput
              onChange={(e) => handleSearchChange(e.target.value)}
              placeholder="Pesquise por departamento..."
            />
          </Grid>
          <Grid item style={{ paddingTop: isSmallScreen ? 8 : '' }}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonAdd}
              onClick={handleAddDepartment}
            >
              <AddIcon className={classes.iconAdd} /> Adicionar Departamento
            </Button>
          </Grid>
        </Grid>
        <Portlet className={classes.grow}>
          <div className={classes.tableWrapper}>
            {!loading && data.length === 0 && (
              <EmptyList message="Não há departamentos para serem visualizados" />
            )}
            {loading && <OverlayLoading />}
            {!loading && (
              <div className={classes.listWrapper}>
                {data.length > 0 && (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>
                          <TableSortLabel
                            active={sort === 'name'}
                            onClick={() => handleSortChange('name')}
                            direction={direction}
                          >
                            Departamento
                          </TableSortLabel>
                        </TableCell>
                        <TableCell />
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data.map((item) => (
                        <TableRow
                          hover
                          key={item.id}
                          className={classes.tableRow}
                        >
                          <TableCell>{item.name || '-'}</TableCell>
                          <TableCell align="right">
                            <div className={classes.tableCellActions}>
                              <IconButton
                                className={classes.editIcon}
                                onClick={() => handleEditDepartment(item.id)}
                              >
                                <CustomIcon pathComponent={mdiPencil} />
                              </IconButton>
                              <IconButton
                                className={classes.iconButton}
                                onClick={() => handleRemoveDepartment(item.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </div>
            )}
          </div>

          {!loading && data.length > 0 && (
            <ListFooter
              options={options}
              onChangeRowsPerPage={handleChangeRowsPerPage}
              onChangePage={handleChangePage}
            />
          )}
        </Portlet>
      </div>
      <DepartmentDialog
        id={departmentId}
        open={openDeparmentDialog}
        onClose={handleCloseDeparmentDialog}
      />
      <ConfirmDialog
        open={openConfirmDialog}
        title="Atenção"
        description="Deseja realmente excluir este departamento?"
        onCancel={handleRemoveCancel}
        onAccept={handleRemoveAccept}
      />
    </>
  )
}

export default DepartmentsPage
